import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AppComponent } from './app.component';
import { APP_ROUTER_PROVIDER } from './app.routes';
import { ServicesOverviewComponent } from './services-overview/services-overview.component';
import { StubsOverviewComponent } from './stubs-overview/stubs-overview.component';
import { StubsDataComponent } from './stubs-data-add/stubs-data-add.component';
import { KeysPipe } from './stubs-data-add/stubs-data-add.component';
import { ServiceDetailsComponent } from './service-details/service-details.component';
import { TemplateDetailsComponent } from './template-details/template-details.component';

import { CookieService } from 'ngx-cookie-service';
import { StubsService } from './Services/stubs.service';
import { NameFilterPipe } from './pipes/name-filter.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';

import { SharedData } from './shared-data/shared-object.service';
import { Config } from './app.config';

import { AccordionModule } from 'primeng/primeng';     //accordion and accordion tab
// import { MenuItem } from 'primeng/primeng';            //api
import { CalendarModule } from 'primeng/primeng';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthenticationService } from './Services/authentication.service';
import { ChatService } from './Services/chat.sevice';
import { WebsocketService } from './Services/websocket.service';

import { TryItComponent } from './common/components/try-it/try-it.component';
import { AutomationModule } from './automation/automation.module';
import { AutomationComponent } from './common/components/automation-data/automation-data.component';

@NgModule({
  declarations: [
    AppComponent,
    ServicesOverviewComponent,
    StubsOverviewComponent,
    StubsDataComponent,
    NameFilterPipe,
    ServiceDetailsComponent,
    TemplateDetailsComponent,
    OrderByPipe,
    KeysPipe,
    TryItComponent,
    AutomationComponent
  ],
  imports: [
    BsDropdownModule.forRoot(),
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule,
    APP_ROUTER_PROVIDER,
    ConfirmationPopoverModule.forRoot({
      confirmButtonType: 'main',
      cancelButtonType: 'main-outline' // set defaults here
    }),
    AccordionModule,
    CalendarModule,
    AutomationModule
  ],
  providers: [Config, CookieService, AuthenticationService, StubsService, SharedData, WebsocketService, ChatService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts